import React from 'react'
import Box from '@mui/material/Box'
import { OperatorEmptyState } from '@/shared/operator'

export type WorkspaceEmptyReason =
  | 'connection'
  | 'object'
  | 'report'
  | 'printSession'

const COPY: Record<WorkspaceEmptyReason, { kicker: string; message: string; tone?: 'neutral' | 'warn' }> = {
  connection: { kicker: 'Workspace', message: 'SELECT A CONNECTION FIRST' },
  object: { kicker: 'Workspace', message: 'OBJECT NAME IS REQUIRED' },
  report: { kicker: 'Report', message: 'SELECT A CONNECTION AND REPORT' },
  printSession: {
    kicker: 'Print',
    message: 'PRINT THE DOCUMENT AGAIN TO REOPEN',
    tone: 'warn',
  },
}

export interface WorkspaceEmptyGateProps {
  reason: WorkspaceEmptyReason
}

export function WorkspaceEmptyGate({ reason }: WorkspaceEmptyGateProps) {
  const { kicker, message, tone } = COPY[reason]
  return (
    <Box
      sx={{
        height: '100%',
        minHeight: 200,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <OperatorEmptyState kicker={kicker} tone={tone}>
        {message}
      </OperatorEmptyState>
    </Box>
  )
}
